var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetbanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_10492_60305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10492_60305",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10492_60305",
    transform: "scale(0.010101 0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10492_60305",
    width: 99,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABgCAMAAAA+cTwJAAAAq1BMVEUAAAAoef8oeP8oeP8oef/m8P8pef/n8P/n8P/o8P/o8f/f7//n8P/j7/8pef/o8f/l8P/n7/8pef/m8P/m7/+awP+51f/n8f/n7/8pef/l7//n7/8nev8oeP8gcP+Ouf8pef/o8P8qev8peP8pdv8pef8AIqXn8P9zidKItP/K1vQdPLDZ4/plfMyCltgOL6o6Vbu7yu6Ro91Xb8etvOlIYsEsSbbK1/Sfr+PhdSx2AAAAJXRSTlMAv0Bgn4DfIN/vjxC/QK9vYEDvz3DXp5+AcFAwMCAQ78+vn5BQjv9w8QAAAcFJREFUaN7s1clygkAUheHOQAigFSmHWLpIZeE92IyKJnn/J4tt4JbBpGyG3vW3gw1wqB+EZVmWZVn6xqOVMMwH4AiT3CmUZ1cYM/EASADeRJgR+DhJKcKJHwgD1s8A5AcRxdLQXi9qpywnJd/DwKsPRgCSlGplAuDVHTQKtdMupgrvFQ4bBTL6LRpyL/e8U0FNRwlgOsheKw/AIaZr8UHtNRksij9VqfTd6RxFQSz9xK4kxqn0jGKfEyvReKxYpeLNuu/0XkfBJBRJF1JOpV8UDD+I8V7rTjsB/PFgCT/HpYxT6RDFkRoiKBE1lBLAyG25039RZFXxDfGudSo+3+2VvOD5+nxa3ClH0ULBqehG8ZWTnk6pOBxFa6nmXm71R22NU7k91xhIsqirLAFCcUuAvjRe+xL9LIWG0FEWW7ZwKnM+9ebUtmyuDmeh0PewYfeicsennkRtwx7Fmb3Gd7t0qAMgDANhuNtNT8yRsIUAff9XxLAqSJra3SfP/ObYYIMNNthgY5lGBnCqufA6bGqY1CQAWZx2jfNGssbd4oRSSk2mTMnUnw2yqJH9uoT0pn5tSMQeP63fltzqJkRERPTlAXjRIhWgtJUHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbanking);
export default __webpack_public_path__ + "static/media/netbanking.2a4c82bd865265807c5cdaa8a76e410a.svg";
export { ForwardRef as ReactComponent };